@if (isAdmin) {
    <af-full-table class="w-100 h-100"
                   [filterFields]="filterFields"
                   [filterEvent]="tableEvent?.filter"
                   (tableUpdateListener)="loadDocuments($event)"
                   [dataSource]="dataSource"
                   [totalElements]="totalElements"
                   [showImport]="false"
                   [showExport]="false"
                   [columnTranslationPrefixes]="{name: 'knowledgeBase', type: 'knowledgeBase'}"
                   emptyStateIconName="ic_empty_state_no_docs"
                   emptyStateTitleTranslationKey="i18n_af_emptyStateTitleKnowledgeDocumentsNotCreated"
                   [emptyStateSubtitleTranslationKey]="mode === 'non_archive' ? 'i18n_af_emptyStateSubtitleKnowledgeDocumentsNotCreated' : undefined"
                   [emptyStateButtonLabel]="mode === 'non_archive' ? 'i18n_af_buttonAddFile' : undefined"
                   (emptyStateClickListener)="addDocumentClickListener.emit()"
                   emptyStateSearchSubtitleTranslationKey="i18n_af_emptyStateSubtitleKnowledgeDocumentsSearchResult"
                   placeholderContext="knowledgeDocuments"/>
} @else {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <div class="w-100 overflow-y-scroll mt-16" fxFlex>
            <af-knowledge-base-categories [mode]="'documents'"/>
        </div>
    </div>
}
